import { RootState } from 'editor/src/store/index';

import getSpreadPage from './getSpreadPage';

const getNonPersonalizableMediaElements = (state: RootState, spreadIndex: number, pageIndex: number) =>
  getSpreadPage(state, spreadIndex, pageIndex)?.groups.media?.filter((element) => !!element.personalizationLocked);

export default getNonPersonalizableMediaElements;
